import React, { useEffect } from 'react';
import Layout from '../../templates/Layout';
import { useNoticeBar } from '../../molecules/NoticeBar/NoticeBar';
import { GET_BANNER_MESSAGE } from '../../../graph-queries/common/config';
import { useQuery } from '@apollo/client';

const HomePageContent: React.FC = () => {
  const { sendInfo } = useNoticeBar();
  const {data: message} = useQuery(GET_BANNER_MESSAGE) || '';
  useEffect(() => {
    if (message?.bannerMessage) {
      sendInfo(message.bannerMessage, Infinity);
    }
  }, [message]);
  return (
    <div className="container">
      <div className="row mb-5 mt-10">
        <div className="col-md-8 col-lg-5 mx-md-auto mx-lg-0">
          <h2 className="display-4 lh-1-375">
            Welcome to the Companion App, the app built for you.
          </h2>
        </div>
        <div className="col-md-8 col-lg-5 offset-lg-1 mx-auto">
          <div className="lead lh-1-75">
            <p className="opacity-100 mb-5">
              We want to fill the gaps and be the glue that gives you a seamless experience as you
              manage and operate your asset. Less time booting up different tools and searching for
              data, more time having cross-discipline conversations and getting work done. Together
              with the 3D digital twin, we will enable Virtual Asset Management.
            </p>
            <p className="opacity-100 mb-7">
              <strong>To get started</strong>, select your asset in the dropdown at the top right
              and then choose the feature you want to use in the middle.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 mx-auto">
          <h2 className="lh-1-5 mb-6">
            To get this right, we need your help. We know our existing data foundation needs
            correcting. You are also the best person to tell us what the truth is. So please help us
            make the virtual asset match the real asset by submitting feedback below.
          </h2>
          <div style={{ textAlign: 'center' }}>
            <a
              href="https://digitalfeedback.bpglobal.com/feedback_gui/_BLEQJVi"
              className="mb-6 rounded-pill btn btn-darker-primary btn-lg"
            >
              Submit Feedback
            </a>

            <div className="lead">
              You can also get to the feedback page anytime by scrolling down to the bottom and
              selecting Leave Feedback.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomePage: React.FC = () => (
  <Layout>
    <HomePageContent />
  </Layout>
);
export default HomePage;
